import axios from "axios";
export default {
  state: {
    specie: [],
  },
  getters: {
    get_specie: (state) => {
      return state.specie;
    },
    get_specie_by_id: (state) => (id_specie) => {
      return state.specie.find((specie) => specie.id == id_specie);
    },
  },
  mutations: {
    set_specie(state, specie) {
      state.specie = specie;
    },
    set_new_specie(state, specie) {
      state.specie.push(specie);
    },
    delete_specie(state, id_specie) {
      let index = state.specie.findIndex((spec) => spec.id == id_specie);
      state.specie.splice(index, 1);
    },
    set_edit_specie(state, payload) {
      let index = state.specie.findIndex((spec) => spec.id == payload.id);
      state.specie.splice(index, 1, payload);
    },
    change_specie_img(state, payload) {
      let specie = state.specie.find((spec) => spec.id == payload.id_specie);
      if (specie) {
        specie.img_md5 = payload.md5;
      }
    },
    add_nuovo_colore_specie(state, payload) {
      let specie = state.specie.find((spec) => spec.id == payload.id_specie);
      specie.colori.push(payload.colore);
    },
    edit_nome_colore_specie(state, payload) {
      let specie = state.specie.find((spec) => spec.id == payload.id_specie);
      if (specie) {
        let colore = specie.colori.find((col) => col.id == payload.id_colore);
        if (colore) {
          colore.nome = payload.nome;
        }
      }
    },
    edit_img_colore_specie(state, payload) {
      let specie = state.specie.find((spec) => spec.id == payload.id_specie);
      if (specie) {
        let varieties = specie.variety.filter(vari => vari.id_colore == payload.id_colore)
        varieties.forEach(vari => {
          vari.md5_colore = payload.md5;
        })
      }
    },
    remove_colore_specie(state, payload) {
      let specie = state.specie.find((spec) => spec.id == payload.id_specie);
      if (specie) {
        specie.colori = specie.colori.filter(
          (colore) => colore !== payload.id_colore
        );
      }
    },
    set_nuova_serie_specie(state, payload) {
      let specie = state.specie.find((spec) => spec.id == payload.id_specie);
      if (specie) {
        specie.series.push(payload.serie);
      }
    },
    delete_serie_specie(state, payload) {
      let specie = state.specie.find((spec) => spec.id == payload.id_specie);
      if (specie) {
        specie.series = specie.series.filter(
          (serie) => serie.id !== payload.id_serie
        );
      }
    },
    set_nuova_varieta_specie(state, payload) {
      let specie = state.specie.find((spec) => spec.id == payload.id_specie);
      if (specie) {
        specie.variety.push(payload.variety);
      }
    },
    delete_varieta_specie(state, payload) {
      let specie = state.specie.find((spec) => spec.id == payload.id_specie);
      if (specie) {
        specie.variety = specie.variety.filter(
          (varieta) => varieta.id !== payload.id_varieta
        );
      }
    },
    set_specie_tempo_vendita(state, { id_specie, tempo_vendita }) {
      let specie = state.specie.find((spec) => spec.id == id_specie);
      if (specie) {
        specie.tempo_vendita = tempo_vendita;
      }
    },
  },
  actions: {
    fetch_specie(context) {
      return new Promise((resolve, reject) => {
        let url = process.env.VUE_APP_API_ROOT + "/admin/specie";
        let auth = context.getters.get_credential;

        caches.match(url).then((cachedResponse) => {
          if (cachedResponse) {
            cachedResponse.json().then((data) => {
              context.commit("set_specie", data);
              resolve();
            });
          }
          axios
            .get(url, { auth: auth })
            .then((res) => {
              context.commit("set_specie", res.data);
              caches.open("listino_2.0-dynamic").then((cache) => {
                cache.put(url, new Response(JSON.stringify(res.data)));
              });
              resolve();
            })
            .catch((err) => {
              reject(err);
            });
        });
      });
    },
    create_new_specie(context, payload) {
      return new Promise((resolve, reject) => {
        let url = process.env.VUE_APP_API_ROOT + "/admin/specie";
        let auth = context.getters.get_credential;
        axios
          .post(url, payload, { auth: auth })
          .then((res) => {
            context.commit("set_new_specie", res.data);
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    elimina_specie(context, payload) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT + "/admin/specie/" + payload.id_specie;
        let auth = context.getters.get_credential;
        axios
          .delete(url, { auth: auth })
          .then((res) => {
            context.commit("delete_specie", payload.id_specie);
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    edit_specie(context, payload) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT + "/admin/specie/" + payload.id_specie;
        let auth = context.getters.get_credential;
        axios
          .put(url, payload, { auth: auth })
          .then((res) => {
            context.commit("set_edit_specie", res.data);
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    patch_specie_tempo_vendita(context, payload) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT +
          "/admin/specie/" +
          payload.id_specie +
          "/tempo_vendita";
        let auth = context.getters.get_credential;
        axios
          .patch(url, { tempo_vendita: payload.tempo_vendita }, { auth: auth })
          .then(() => {
            context.commit("set_specie_tempo_vendita", {
              id_specie: payload.id_specie,
              tempo_vendita: payload.tempo_vendita,
            });
            resolve();
          })
          .catch((err) => reject(err));
      });
    },
    nuova_img_specie(context, payload) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT +
          "/admin/specie/" +
          payload.id_specie +
          "/img";
        let auth = context.getters.get_credential;
        axios
          .post(url, payload.formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            auth: auth,
          })
          .then((res) => {
            context.commit("change_specie_img", {
              id_specie: payload.id_specie,
              md5: res.data.md5,
            });
            resolve("ok");
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            //context.commit("set_loading", false)
          });
      });
    },
    nuovo_colore_specie(context, payload) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT +
          "/admin/specie/" +
          payload.id_specie +
          "/colore/" +
          payload.nome;
        let auth = context.getters.get_credential;
        payload.formData.append("id_serie", payload.id_serie);
        axios
          .post(url, payload.formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            auth: auth,
          })
          .then((res) => {
            context.commit("add_nuovo_colore_specie", {
              id_specie: payload.id_specie,
              colore: res.data.id,
            });
            resolve("ok");
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    cambia_nome_colore_specie(context, payload) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT +
          "/admin/specie/" +
          payload.id_specie +
          "/colore/" +
          payload.id_colore +
          "/nome";
        let auth = context.getters.get_credential;
        axios
          .put(url, payload, { auth: auth })
          .then(() => {
            context.commit("edit_nome_colore_specie", payload);
            resolve("ok");
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    cambia_img_colore_specie(context, payload) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT +
          "/admin/specie/" +
          payload.id_specie +
          "/cambia_colore/" +
          payload.id_colore +
          "/image";
        let auth = context.getters.get_credential;
        axios
          .put(url, payload.formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            auth: auth,
          })
          .then((res) => {
            payload.md5 = res.data.md5;
            context.commit("edit_img_colore_specie", payload);
            resolve("ok");
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    elimina_colore_specie(context, payload) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT +
          "/admin/specie/" +
          payload.id_specie +
          "/colore/" +
          payload.id_colore;
        let auth = context.getters.get_credential;
        axios
          .delete(url, { auth: auth })
          .then(() => {
            context.commit("remove_colore_specie", {
              id_specie: payload.id_specie,
              id_colore: payload.id_colore,
            });
            resolve("ok");
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetch_colore_by_id(context, id_colore) {
      return new Promise((resolve, reject) => {
        let url = process.env.VUE_APP_API_ROOT + "/specie/colore/" + id_colore;
        let auth = context.getters.get_credential;
        axios
          .get(url, { auth: auth })
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetch_colori_by_id(context, array_colori) {
      return new Promise((resolve, reject) => {
        let url = process.env.VUE_APP_API_ROOT + "/specie/colori";
        let auth = context.getters.get_credential;
        axios
          .post(url, { colori: array_colori }, { auth: auth })
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    nuova_serie_specie(context, payload) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT +
          "/admin/specie/" +
          payload.id_specie +
          "/serie";
        let auth = context.getters.get_credential;
        axios
          .post(url, payload, { auth: auth })
          .then((res) => {
            context.commit("set_nuova_serie_specie", {
              id_specie: payload.id_specie,
              serie: res.data,
            });
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    elimina_serie_specie(context, payload) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT +
          "/admin/specie/" +
          payload.id_specie +
          "/serie/" +
          payload.id_serie;
        let auth = context.getters.get_credential;
        axios
          .delete(url, { auth: auth })
          .then((res) => {
            context.commit("delete_serie_specie", payload);
            resolve(res);
          })
          .catch((err) => {
            alert("Serie Collegata. Impossibile eliminare");
            reject(err);
          });
      });
    },
    nuova_varieta_specie(context, payload) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT +
          "/admin/specie/" +
          payload.id_specie +
          "/varieta";
        let auth = context.getters.get_credential;
        axios
          .post(url, payload, { auth: auth })
          .then((res) => {
            context.commit("set_nuova_varieta_specie", {
              id_specie: payload.id_specie,
              variety: res.data,
            });
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    elimina_varieta_specie(context, payload) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT +
          "/admin/specie/" +
          payload.id_specie +
          "/varieta/" +
          payload.id_varieta;
        let auth = context.getters.get_credential;
        axios
          .delete(url, { auth: auth })
          .then((res) => {
            context.commit("delete_varieta_specie", payload);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    change_serie_colore_specie(context, payload) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT +
          "/admin/specie/colore/" +
          payload.id_colore +
          "/series";
        let auth = context.getters.get_credential;
        axios
          .put(url, { series: payload.id_series }, { auth: auth })
          .then(() => {
            resolve("ok");
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetch_info_specie_by_id(context, payload) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT +
          "/specie/" +
          payload.id_specie +
          "/info";
        let auth = context.getters.get_credential;
        axios
          .get(url, { auth: auth })
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    send_specie_info(context, payload) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT +
          "/admin/specie/" +
          payload.id_specie +
          "/info";
        let auth = context.getters.get_credential;
        axios
          .put(
            url,
            { categoria: payload.categoria, text: payload.text },
            { auth: auth }
          )
          .then(() => {
            resolve("ok");
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    send_specie_info_img(context, payload) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT +
          "/admin/specie/" +
          payload.id_specie +
          "/info_img";
        let auth = context.getters.get_credential;
        axios
          .post(url, payload.formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            auth: auth,
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    send_serie_info(context, payload) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT +
          "/admin/specie/" +
          payload.id_specie +
          "/serie/" +
          payload.id_serie +
          "/info";
        let auth = context.getters.get_credential;
        axios
          .put(url, { info: payload.info }, { auth: auth })
          .then(() => {
            resolve("ok");
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetch_info_serie_by_id(context, payload) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT +
          "/specie/" +
          payload.id_specie +
          "/serie/" +
          payload.id_serie +
          "/info";
        let auth = context.getters.get_credential;
        axios
          .get(url, { auth: auth })
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    send_serie_info_img(context, payload) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT +
          "/admin/specie/" +
          payload.id_specie +
          "/serie/" +
          payload.id_serie +
          "/info_img_serie";
        let auth = context.getters.get_credential;
        axios
          .post(url, payload.formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            auth: auth,
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    send_serie_brand_img(context, payload) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT +
          "/admin/specie/" +
          payload.id_specie +
          "/serie/" +
          payload.id_serie +
          "/brand_img_serie";
        let auth = context.getters.get_credential;
        axios
          .post(url, payload.formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            auth: auth,
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
